export default __webpack_public_path__ + "static/pf-ebcb5f3a747b9a42373d4c6d694dc10a.svg";